<template>
  <div>
    <el-input class="search-el" size="small" v-model="query.order_no" placeholder="订单号"></el-input>
    <el-input class="search-el" size="small" v-model="query.like" placeholder="商品/昵称/手机号"></el-input>
    <el-select class="search-el" size="small" v-model="query.order_status" placeholder="订单状态">
      <el-option label="全部订单" value="">全部订单</el-option>
      <el-option 
        v-for="(item,index) in status_msg"
        :key="index"
        :label="item"
        :value="index">
      </el-option>
    </el-select>
    <el-select class="search-el" size="small" v-model="query.item_type" placeholder="类型">
      <el-option label="全部类型" value=""></el-option>
      <el-option 
        v-for="(item,index) in item_type_msg"
        :key="index"
        :label="item"
        :value="index">
      </el-option>
    </el-select>    
    
    <el-date-picker class="search-el" size="small" v-model="query.date_timestamp" value-format='yyyy-MM-dd HH:mm:ss' type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
    </el-date-picker>

    <el-select class="search-el" size="small" v-model="query.event_user_id" placeholder="销售">
      <el-option label="全部" value=""></el-option>
      <el-option 
        v-for="(item) in employee"
        :key="item.id"
        :label="item.nickname"
        :value="item.id">
      </el-option>
    </el-select>

    <el-select class="search-el" size="small" v-model="query.department_id" placeholder="销售部门" v-if="showSelect">
      <el-option label="销售部门" value=""></el-option>
      <el-option 
        v-for="(item,index) in department"
        :key="index"
        :label="item"
        :value="index">
      </el-option>
    </el-select>

    <el-button type="primary" size="small" @click="getList()">
      查询
    </el-button>
    <el-button type="primary" size="small" @click="exportOrder()">
      导出
    </el-button>
    <el-row>
      <el-table v-loading="loading" :data="list" border size="mini" :stripe="true" style="width: 100%; margin: 20px 0">
        <el-table-column prop="id" label="订单ID" align="center"></el-table-column>
        <el-table-column prop="order_no" label="订单号" align="center"></el-table-column>
        <el-table-column prop="nickname" label="用户昵称" align="center"></el-table-column>
        <el-table-column prop="mobile_phone" label="手机号" align="center"></el-table-column>
        <el-table-column prop="body" label="内容" align="center"></el-table-column>
        <el-table-column prop="total_amount" label="金额" align="center"></el-table-column>
        <el-table-column prop="status_msg" label="状态" align="center"></el-table-column>
        <el-table-column prop="item_type_msg" label="类型" align="center"></el-table-column>
        <el-table-column prop="created_at" label="下单时间" align="center"></el-table-column>
        <el-table-column prop="paid_at" label="支付时间" align="center" width="90"></el-table-column>
        <el-table-column label="销售" align="center">
          <template slot-scope="{row}">
            <div>{{ row.event_user_nickname }}</div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination background @current-change="getList" :current-page.sync="query.page" :page-size="query.limit" layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import {
  orderList,
} from "@/api/employee";
const axios = require('axios');

export default {
  data: function() {
    return {
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        order_no: "",
        like: "",
        order_status: "",
        item_type: "",
        event_user_id: "",
        department_id: "",
        export: 0
      },
      status_msg: [],
      item_type_msg: [],
      employee: [],
      department: [],
      pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        showSelect:true
    };
  },
  created: function() {
    this.getList();
  },
  mounted() {
    let str = this.$route.query.department_id;
    console.log(str);
    if (str) {
      console.log('aaa');
      this.showSelect = false;
      this.query.department_id=str;
    }
    //this.query.department_id=str;
  },
  methods: {
    toChildren(id) {
      this.$router.push({
        path: '/moment/info',
        query: {
          id: id,
        }
      })
    },    
    ref() {
      window.history.go(0);
    },
    getList() {
      this.loading = true;
      orderList(this.query).then(response => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
        this.status_msg = response.data.status_msg;
        this.item_type_msg = response.data.item_type_msg;
        this.employee = response.data.employee;
        this.department = response.data.department;
      });
    },
    exportOrder() {
      this.query.export = 1;
      this.loading = true;

      axios({
        method: 'post',
        url: '/backend/employee/getOrderList',
        data: this.query,
        responseType: 'blob'
      }).then((res) => {
        //console.log(res)
        const link = document.createElement('a')
        let blob = new Blob([res.data],{type: 'application/vnd.ms-excel'});
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', '销售.xls')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.loading = false;
        this.query.export = 0;
      }).catch(error => {
        this.$Notice.error({
          title: '错误',
          desc: '网络连接错误'
        })
        console.log(error)
      })
    }
  }
};
</script>

